/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
import React from 'react';
import packageJson from '../package.json';

global.appVersion = packageJson.version;

// From https://dev.to/flexdinesh/cache-busting-a-react-app-22lk

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        // Check if we've already tried to refresh for this version
        // This prevents infinite reload loops if the browser keeps serving old cached files
        const refreshAttemptKey = `cache-refresh-attempted-${global.appVersion}`;
        if (sessionStorage.getItem(refreshAttemptKey)) {
          console.warn('Cache refresh already attempted for this version, proceeding with current version');
          return;
        }

        // Mark that we've attempted a refresh
        sessionStorage.setItem(refreshAttemptKey, 'true');

        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then((names) => {
            for (const name of names) caches.delete(name);
          });
        }

        // delete browser cache and hard reload
        window.location.reload(true);
      },
    };
  }

  componentDidMount() {
    fetch('/meta.json')
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;

        const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);

        // Check if we've already tried to refresh for this version
        const refreshAttemptKey = `cache-refresh-attempted-${currentVersion}`;
        const alreadyAttempted = sessionStorage.getItem(refreshAttemptKey);

        if (shouldForceRefresh && !alreadyAttempted) {
          this.setState({ loading: false, isLatestVersion: false });
        }
        else {
          // Either we have the latest version, or we've already tried refreshing
          this.setState({ loading: false, isLatestVersion: true });
        }
      })
      .catch((error) => {
        // If meta.json fetch fails (network issues, CORS, Safari caching, etc.),
        // assume we have the latest version and proceed with loading the app.
        // This prevents the app from being stuck in a loading state.
        console.warn('Failed to fetch meta.json for version check:', error);
        this.setState({ loading: false, isLatestVersion: true });
      });
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
  }
}

export default CacheBuster;
